export const GET_TRANSACTION_LIST_CONSTANT = 'GET_TRANSACTION_LIST';
export const CLEAR_TRANSACTION_LIST = 'CLEAR_TRANSACTION_LIST';
export const RES_PER_PAGE = 12;
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const CUSTOM_DATE_FILTER_FORMAT = 'Do MMMM YYYY';
export const FILTER_TAB_DATE_FORMAT = 'MMMM';
export const TOTAL_FILTER_TABS = 3;
export const VALID_DATE_MONTH_REGEX = /^[0-9]{0,2}$/;
export const VALID_YEAR_REGEX = /^[0-9]{0,4}$/;
export const TRANS_PAYMENT_STATUS = {
    success: 'Success',
    refund: 'Refund', // to confirm later
    pending: 'Pending',
};

export const TRANS_BUTTON_API_KEY = {
    1: 'refund',
    2: 'resendLink',
    3: 'verifyCode',
    4: 'refunded',
}

export const TRANS_BUTTON_ACTION = {
    refund: {
        id: 1,
        label: 'Refund',
    },
    resendLink: {
        id: 2,
        label: 'Re-send payment link'
    },
    verifyCode: {
        id: 3,
        label: 'Verify code'
    },
    refunded: {
        id: 4,
        label: 'Refunded'
    },
};

export const TRANS_PAYMENT_TAG = {
    refund: {
        min: 8,
        max: 11
    },
    noshow: 12
}

export const TRANS_PAYMENT_TYPE = {
    directDeposit: 'Direct deposit'
}